// extracted by mini-css-extract-plugin
module.exports = {"content":"content-3b69156848fb840b6e1af761722c7fbb","mark":"mark-cd9871ea714eb5db8bf31fe2232d9fb6"};